import React from "react";
import Banner from "../components/home/banner";
import CountDown from "../components/home/count-down";
import Couple from "../components/home/couple";
import CoupleDetail from "../components/home/couple-detail";
import Footer from "../components/home/footer";
import Rsvp from "../components/home/rsvp";
import Wedding from "../components/home/wedding";

function Home() {
  return (
    <>
      <Banner />
      <Couple />
      <CoupleDetail />
      <CountDown />
      <Wedding />
      <Rsvp />
      <Footer />
    </>
  );
}

export default Home;
